<template>
  <Listbox
    v-slot="{ open }"
    as="div"
    by="slug"
    class="relative w-full"
    :model-value="modelValue"
    @update:model-value="(value) => emit('update:modelValue', value)"
  >
    <!-- HEADER -->
    <ListboxButton
      :id="`headlessui-listbox-button-${title}`"
      v-slot="{ value }"
      class="w-full"
    >
      <div class="flex w-full items-center justify-between gap-[0.25em]">
        <span class="truncate" :class="{ 'uppercase': uppercase, 'typo-body-lg': size === 'sm', 'typo-body-3xl md:typo-body-4xl': size === 'md' }">
          {{ value.title || placeholder || $t('forms.please_chose') }}
        </span>
        <IconChevron class="size-[1.175em] shrink-0 rotate-0 transition-all ui-open:rotate-180" />
      </div>
    </ListboxButton>

    <!-- OPTIONS -->
    <Transition :open="open" name="fade">
      <ListboxOptions
        class="
          absolute top-[calc(100%+0.25rem)] z-[100] mt-1 w-full max-w-full overflow-y-auto overflow-x-hidden
          rounded-sm bg-white shadow-sm
        "
      >
        <ListboxOption
          v-for="option in options"
          :key="option.slug"
          :value="option"
          :class="{ 'uppercase': uppercase, 'typo-body-lg': size === 'sm', 'typo-body-2xl md:typo-body-3xl': size === 'md' }"
          class="max-w-full cursor-pointer truncate p-2 text-center transition-colors hover:bg-theme-50"
        >
          {{ option.title }}
        </ListboxOption>
      </ListboxOptions>
    </Transition>
  </Listbox>
</template>

<script setup lang="ts">
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  options: {
    type: Array as () => Array<{
      slug: string
      title: string
    }>,
    default: () => [],
  },
  modelValue: {
    type: Object as () => {
      slug: string
      title: string
    },
    default: () => ({}),
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<'sm' | 'md'>,
    default: 'md',
  },
})

const emit = defineEmits(['update:modelValue'])
</script>
